module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-500-active-bft-5a2f34cbff0671f0f191639cb3dae6d8.png";